import { BlockProps, KeepGoing, SongCard } from "./Blocks";
import { CoverUpsell } from "../Upsell";

// Right column on your own finished cover. The separate upsell and
// suggestion blocks that used to stack here now live inside "Keep going";
// Basic subscribers get one "hear it in your own voice" card above it.
export function Aside(props: BlockProps) {
  const voice = props.conversion?.models?.[0] ?? props.conversion?.model;
  return (
    <aside className="tw-flex tw-flex-col tw-gap-3.5">
      <CoverUpsell
        placement="ready"
        conversionId={props.conversion?._id}
        subscriptions={props.signedInUser?.subscriptions}
        voice={voice as any}
      />
      <KeepGoing {...props} />
      <SongCard {...props} />
    </aside>
  );
}
